<template>
  <a :href="href" :target="target" :style="fontStyle" @mouseenter="enter()" @mouseleave="leave()">
    <slot/>
  </a>
</template>

<script>
export default {
  name: 'FontBigger',
  props:{
      smallFontSize: { type:Number, default:13 },
      bigFontSize:   { type:Number, default:15 },
      target:        { type:String, default:'_self'},
      href:          { type:String, default:null}
  },
  data() {
    return {
        fontStyle:{
            fontSize: this.smallFontSize+'px',
            transition: 'all'+' 0.3s',
            color: 'inherit'
        }
    }
  },
  methods:{
      enter(){
        this.fontStyle.fontSize = this.bigFontSize+'px';
      },
      leave(){
        this.fontStyle.fontSize = this.smallFontSize+'px';
      }
  }
}
</script>

<style scoped lang="stylus">
  a
    padding 0 10px 0 10px
</style>
